import {PublicClientApplication} from "@/@azure/msal-browser";
import Rpc from "@/Rpc";
import {getAvailableUserConnections} from "@/components/subscriptions/Subs";
import EventBus from "@/utils/EventBus";

const msalConfig = {
    auth: {
        clientId: "642908ea-3d5e-4cc5-933c-05b4ee1bb1bb",
        authority: "https://login.microsoftonline.com/f597f052-390d-4657-b4c1-4845e5ec46a2",
        redirectUri: window.location.href,
    }
};
let msalInstance;

export async function azureSignIn(){
    if(!msalInstance){
        msalInstance = new PublicClientApplication(msalConfig);
        await msalInstance.initialize();
    }
    try {
        const loginResponse = await msalInstance.loginPopup();
        const accessToken = loginResponse.accessToken;
        await processMsCode(accessToken);

    } catch (err) {
        console.error(err);
    }
}

async function processMsCode(code){
    let userData = await Rpc.Session.decodeAzureId(code);
    if(userData.logged && userData.email){
        let servers = await getAvailableUserConnections(userData.email);
        EventBus.$emit(Events.googleSignIn, userData, servers);
    } else {
        EventBus.$emit(Events.azureSignInError, userData);
    }
}

export function azureSignInEnabled() {
    return true;
}
